import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import sphereAnimationDarkJson from '@/data/lottie-animations/sphereAnimationDark.json'

const schema: LandingScreenSchema = {
	config: {
		dynamicLandingType: 'male_funnel',
	},

	order: [
		'LandingHead',
		'LandingTitle',
		'LandingImage', // <- if dynamicLandingData.image_url
		'LandingLottieAnimation', // <- else
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingHead: (): LandingComponentsConfig['LandingHead'] => ({
			logoAlignment: 'left',
			logoColor: 'primary',
		}),

		LandingTitle: ({ $t, ctx }): LandingComponentsConfig['LandingTitle'] => ({
			title: ctx.dynamicLandingData?.title ?? $t('pages.landing.male_funnel.title'),
			size: 'small',
		}),

		LandingImage: ({ ctx }): LandingComponentsConfig['LandingImage'] => ({
			hide: !Boolean(ctx.dynamicLandingData?.image_url),
			img: ctx.dynamicLandingData?.image_url,
			customStyles: {
				maxHeight: '50vh',
				marginTop: 'var(--size-16)',
				marginBottom: 'var(--size-16)',
			},
		}),

		LandingLottieAnimation: ({ ctx }): LandingComponentsConfig['LandingLottieAnimation'] => ({
			hide: Boolean(ctx.dynamicLandingData?.image_url),
			animationData: ctx.dynamicLandingData?.animation_url || sphereAnimationDarkJson,
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: ({ ctx }): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 4000,
			label: ctx.dynamicLandingData?.loader?.label,
			note: ctx.dynamicLandingData?.loader?.note,
		}),

		LandingFooter: ({ ctx }): LandingComponentsConfig['LandingFooter'] => ({
			description: ctx.dynamicLandingData?.feature_description,
			disclaimer: ctx.dynamicLandingData?.disclaimer,
		}),
	},
}

export default schema
